import { render, staticRenderFns } from "./FabricTable.vue?vue&type=template&id=6589e658"
import script from "./FabricTable.vue?vue&type=script&lang=js"
export * from "./FabricTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports